import Route from '@ember/routing/route';

export default class MarketRevenueInsightPortfolioDetailsModalRoute extends Route {}
